DialogController = App.loadClass 'core::Angular/DialogController'

class exports.BulkDeleteController extends DialogController
    constructor: (@scope, @transitions, @state, @modalInstance, Data, @http) ->
        super(@scope, @transitions, @modalInstance)

        # Instance Data
        @scope.title = 'Confirm Deletion'
        @scope.multiple = Data.multiple
        @scope.delete_array = Data.selected

        # Function Declarations
        @scope.confirmDelete = @confirmDelete

    confirmDelete: () =>
        @handleMessages @http.post 'backend/grower/fieldprint/delete', { fieldprints: @scope.delete_array }

    # Boilerplate code for handling the messagewriter
    handleMessages: (promise) =>
        promise.then (response) =>
            if response?.data?.status?.type
                @closeWithAlert response.data.status
        return promise
